// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
export interface DatabaseDefinition {
  /** The id of the database. */
  id?: string;
}
